<style>
  .spinner {
    display: block;
    position: relative;
    width: 125px;
    height: 125px;
    border-radius: 50%;
    border: 4px solid transparent;
    border-top: 4px solid rgb(82, 94, 138);
    animation: spin 2s linear infinite;
  }

  .spinner::before,
  .spinner::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    border: 4px solid transparent;
  }

  .spinner::before {
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    border-top-color: rgb(104, 134, 149);
    animation: spin 3.5s linear infinite;
  }

  .spinner::after {
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    border-top-color: rgb(3, 155, 229);
    animation: spin 1.75s linear infinite;
  }
    
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>


<div class="spinner"></div>
